'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Toolbar = require('../TopNavigation/Toolbar.js');
var Close = require('../../../IconsAndImages/Icons/Close.js');
var makeStyles = require('../../Styles/makeStyles.js');
var Drawer$1 = require('../../../node_modules/@material-ui/core/esm/Drawer/Drawer.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function () {
  return {
    paper: {
      width: 328,
      padding: 8,
      boxSizing: 'border-box'
    }
  };
});
var drawerTypes = {
  settings: {
    width: 350,
    title: 'Settings',
    anchor: 'right'
  },
  filters: {
    width: 350,
    title: 'Filters',
    anchor: 'right'
  },
  tasks: {
    width: 350,
    title: 'Tasks',
    anchor: 'right'
  },
  chat: {
    width: 420,
    title: 'Chat',
    anchor: 'right'
  },
  activityFeed: {
    width: 350,
    title: 'Activity Feed',
    anchor: 'right'
  }
};

function Drawer(props) {
  var open = props.open,
      handleClose = props.handleClose,
      drawerType = props.drawerType,
      anchor = props.anchor,
      children = props.children,
      classes = props.classes,
      toolBarActions = props.toolBarActions,
      version = props.version,
      rest = objectWithoutProperties(props, ["open", "handleClose", "drawerType", "anchor", "children", "classes", "toolBarActions", "version"]);

  var _useStyles = useStyles(),
      paper = _useStyles.paper;

  var drawerContent = children;

  if (drawerType) {
    drawerContent = React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Toolbar, {
      position: "absolute",
      leftIcon: React__default["default"].createElement(Close, null),
      leftIconAction: handleClose,
      pageTitle: drawerTypes[drawerType].title
    }, toolBarActions), React__default["default"].createElement("div", {
      style: {
        width: drawerTypes[drawerType].width,
        marginTop: 76
      }
    }, children));
  }

  return React__default["default"].createElement(Drawer$1["default"], _objectSpread({
    anchor: anchor || (drawerType ? drawerTypes[drawerType].anchor : undefined),
    classes: version === 'v2' ? _objectSpread({
      paper: paper
    }, classes) : classes,
    open: open,
    ModalProps: {
      onBackdropClick: handleClose
    },
    style: {
      overflowX: 'hidden'
    }
  }, rest), drawerContent);
}

module.exports = Drawer;
